module.exports = __webpack_public_path__ + "img/menu-icon-prospects.1fc54ee1.svg";